import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=bf5038c8"
import script from "./BranchForm.vue?vue&type=script&lang=js"
export * from "./BranchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports